import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

export default function useResetFormOnSubmitSuccess() {
  const {
    getValues,
    reset,
    formState: { isSubmitSuccessful },
  } = useFormContext();

  useEffect(() => {
    if (isSubmitSuccessful) {
      const values = getValues();
      reset(values);
    }
  }, [getValues, isSubmitSuccessful, reset]);
}
